<template>
  <span :style="custom" class="seckill-icon"><i>{{tag}}</i></span>
</template>

<script>
  export default {
    name: 'seckill-icon',
    props: {
      tag: {
        type: String,
        default: '',
      },
      custom: {
        type: Object,
        default: () => {},
      }
    }
  }
</script>

<style lang="less" scoped>
  .seckill-icon {
    width: 30px;
    height: 30px;
    background: url("../../assets/img/seckill.png") no-repeat;
    background-size: contain;
    position: absolute;
    top: 5px;
    left: 5px;
    font-size: 10px;
    i {
      width: 100%;
      text-align: center;
      display: block;
      line-height: 18px;
      padding-top: 8px;
      color: #fff;
      transform: rotate(-10deg);
    }
  }

</style>



// WEBPACK FOOTER //
// index.vue?7d259faa